export enum WorkflowNodeType {
  Start = 'BEGIN_NODE',
  End = 'END_NODE',
  LLM = 'llm',
  Condition = 'condition',
  Loop = 'loop',
  Comment = 'comment',
  Sql = 'SQL_NODE',
  JS = 'JS_SCRIPT_NODE',
  FeishuSheet = 'PUSH_FEISHU_TABLE_NODE',
  FeishuNotification = 'PUSH_FEISHU_HOOK_NODE',
  ApiCall = 'API_NODE',
}

export enum NodeFieldsEnum {
  sql = 'sql',
  dataSource = 'dataSource',
  jsCode = 'jsCode',
  link = 'link',
  feishuUrl = 'feishuUrl',
  host = 'host',
  url = 'url',
  serviceType = 'serviceType',
  params = 'params',
  dataMode = 'dataMode',
  archiveThreshold = 'archiveThreshold',
  archivePrefix = 'archivePrefix',
}

export enum ServiceTypeEnum {
  cloudFunc = 'CLOUD_FUNCTION', // 云函数
  cloud = 'CLOUD_HOSTING', // 云托管
}

/**
 * 数据源类型
 */
export enum DataSourceType {
  /** 酒旅公共库 */
  BELINK = 'belink',
  /** 电商公共库 */
  ECOMMERCE = 'ecommerce',
  /** 电商用户库 */
  ECOMMERCE_USER = 'ecommerce_user',
  /** 电商交易库 */
  ECOMMERCE_TRADE = 'ecommerce_trade',
  /** 电商营销库 */
  ECOMMERCE_MARKETING = 'ecommerce_marketing',
  /** 电商任务中心库 */
  ECOMMERCE_TASKCENTER = 'ecommerce_taskcenter',
  /** BI分析库 */
  BI_ANALYSIS = 'bi-analysis',
  /** AI数据源 */
  AI = 'ai',
}
